<template>
  <div class="border-y border-gray-300 bg-white">
    <div class="mx-auto flex max-w-7xl flex-col items-center gap-6 px-4 py-8 sm:flex-row sm:justify-center sm:gap-10 sm:px-6 lg:px-8">
      <p class="text-sm font-semibold text-gray-600">Sends through</p>
      <div class="flex flex-wrap items-center justify-center gap-8">
        <img
          :src="LobLogo"
          alt="Lob"
          class="h-7 w-auto opacity-70 grayscale transition hover:opacity-100 hover:grayscale-0"
        />
        <img
          :src="PostgridLogo"
          alt="PostGrid"
          class="h-7 w-auto opacity-70 grayscale transition hover:opacity-100 hover:grayscale-0"
        />
        <img
          :src="DmmLogo"
          alt="Direct Mail Manager"
          class="h-7 w-auto opacity-70 grayscale transition hover:opacity-100 hover:grayscale-0"
        />
        <img
          :src="ShopifyLogo"
          alt="Shopify"
          class="h-7 w-auto opacity-70 grayscale transition hover:opacity-100 hover:grayscale-0"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import LobLogo from "@/../images/integration-icons/lob-icon.svg";
import PostgridLogo from "@/../images/integration-icons/postgrid-icon.svg";
import DmmLogo from "@/../images/integration-icons/dmm-logo.svg";
import ShopifyLogo from "@/../images/integration-icons/shopify-icon.svg";
</script>
